<span class="site-info-directives" tooltip="{{ tooltipMessage }}" tooltip-placement="right">
    <i class="fa" [ngClass]="icon"></i> {{ status }}
</span>
